class CardContent {
    constructor(element) {
        this.el = element;

        this.init();
    }

    init() {
        this.addHeightProperties()
    }

    addHeightProperties() {

        let cardContent = this.el.querySelector('.card__content')

        this.el.style.setProperty("--true-height", cardContent.offsetHeight + 'px')
        
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const accordionElements = document.querySelectorAll(".card--space");
    
    accordionElements.forEach((element) => {
        new CardContent(element)
    });
});